// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deleteModalPaper__QHYPM.deleteModalPaper__QHYPM {
  margin: 20px;
  padding: 20px;
  border-radius: 16px;
}

.deleteModalPaper__QHYPM.deleteModalPaper__QHYPM h2 {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0;

  font-size: 18px;
  font-weight: 500;
  font-style: normal;
  line-height: 22px;
}

.deleteModalContent__MP2l2.deleteModalContent__MP2l2 {
  padding: 16px 0 !important;
}

.deleteModalContent__MP2l2.deleteModalContent__MP2l2 p {
  font-size: 14px;
  line-height: 22px;
  color: #262732;
}

.deleteModalActions__KeVgg.deleteModalActions__KeVgg {
  padding: 0;
}

.deleteModalCancelButton__K9k7R.deleteModalCancelButton__K9k7R,
.deleteModalDeleteButton__gPrC8.deleteModalDeleteButton__gPrC8 {
  height: 38px;
  margin-left: 16px !important;
  padding: 8px 16px;

  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  text-transform: none;

  border-radius: 19px;
}

.deleteModalCancelButton__K9k7R.deleteModalCancelButton__K9k7R {
  color: #262732;
  background: #f2f2f2;
}

.deleteModalDeleteButton__gPrC8.deleteModalDeleteButton__gPrC8 {
  color: #fff;
  background: #dc3545;
}

.deleteModalCancelButton__K9k7R.deleteModalCancelButton__K9k7R:hover {
  opacity: 0.9;
  background: #f2f2f2;
}

.deleteModalDeleteButton__gPrC8.deleteModalDeleteButton__gPrC8:hover {
  opacity: 0.9;
  background: #dc3545;
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat/Correspondence/DeleteMessageModal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;;EAE9B,UAAU;;EAEV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,YAAY;EACZ,4BAA4B;EAC5B,iBAAiB;;EAEjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;;EAEpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".deleteModalPaper.deleteModalPaper {\n  margin: 20px;\n  padding: 20px;\n  border-radius: 16px;\n}\n\n.deleteModalPaper.deleteModalPaper h2 {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  padding: 0;\n\n  font-size: 18px;\n  font-weight: 500;\n  font-style: normal;\n  line-height: 22px;\n}\n\n.deleteModalContent.deleteModalContent {\n  padding: 16px 0 !important;\n}\n\n.deleteModalContent.deleteModalContent p {\n  font-size: 14px;\n  line-height: 22px;\n  color: #262732;\n}\n\n.deleteModalActions.deleteModalActions {\n  padding: 0;\n}\n\n.deleteModalCancelButton.deleteModalCancelButton,\n.deleteModalDeleteButton.deleteModalDeleteButton {\n  height: 38px;\n  margin-left: 16px !important;\n  padding: 8px 16px;\n\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  text-transform: none;\n\n  border-radius: 19px;\n}\n\n.deleteModalCancelButton.deleteModalCancelButton {\n  color: #262732;\n  background: #f2f2f2;\n}\n\n.deleteModalDeleteButton.deleteModalDeleteButton {\n  color: #fff;\n  background: #dc3545;\n}\n\n.deleteModalCancelButton.deleteModalCancelButton:hover {\n  opacity: 0.9;\n  background: #f2f2f2;\n}\n\n.deleteModalDeleteButton.deleteModalDeleteButton:hover {\n  opacity: 0.9;\n  background: #dc3545;\n}\n"],"sourceRoot":""}]);
// Exports
export var deleteModalPaper = `deleteModalPaper__QHYPM`;
export var deleteModalContent = `deleteModalContent__MP2l2`;
export var deleteModalActions = `deleteModalActions__KeVgg`;
export var deleteModalCancelButton = `deleteModalCancelButton__K9k7R`;
export var deleteModalDeleteButton = `deleteModalDeleteButton__gPrC8`;
export default ___CSS_LOADER_EXPORT___;
